import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/thesis', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const store = data => {
  return httpClient
    .post('/api/thesis', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const committee = data => {
  return httpClient
    .post(`/api/thesis/${data.thesis_reg_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/thesis/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const update = data => {
  return httpClient
    .put(`/api/thesis/${data.thesis_reg_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const destroy = id => {
  return httpClient
    .delete(`/api/thesis/${id}`)
    .then(response => Promise.resolve(response.data))
}
export const attachFile = data => {
  return httpClient
    .post('/api/thesis/attachement-files', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const viewPhoto = (options = {}) => {
  return httpClient
    .get('/api/thesis/view-photos', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const download = id => {
  return httpClient
    .get(`/api/thesis/downloads/${id}`, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response.data))
    .catch(response => Promise.reject(response.data))
}
export const getFile = (thesis_reg_id, Options = {}) => {
  return httpClient
    .get(`/api/thesis/files/${thesis_reg_id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const deleteItem = id => {
  return httpClient
    .post(`/api/thesis/remove/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(response => Promise.reject(response.data))
}
export const fetchCommittee = data => {
  return httpClient
    .get(`/api/thesis/committees/${data.thesis_reg_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const student = (Option = {}) => {
  return httpClient
    .get('/api/thesis/studnets', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  store,
  get,
  find,
  committee,
  update,
  destroy,
  attachFile,
  viewPhoto,
  download,
  getFile,
  deleteItem,
  fetchCommittee,
  student
}
